import { Button } from "components/DesignSystem/Button/Button";
import { Padlock } from "components/icons/Padlock";
import { PadlockIcon } from "components/icons/PadlockIcon";
import { ComponentProps, ReactNode } from "react";

export const BlockedButton = (props: ComponentProps<typeof Button>) => (
  <Button disabled leftIcon={<PadlockIcon />} {...props} />
);
